import type { ICellEditorParams } from "ag-grid-community";

import BooleanInput from "../../../redux-form/BooleanField.js";
import { TableCell } from "../core/TableCell.js";

export const BooleanCellEditor = (props: ICellEditorParams) => {
  const { value } = props;

  if (props.cellStartedEdit) {
    props.stopEditing(true);
  }

  const onChangeListener = (value: boolean) => {
    props.setValue(value);
  };

  return (
    <TableCell style={{ textAlign: "center" }}>
      <BooleanInput
        value={value}
        onChange={onChangeListener} //.api.chan.startEditingCell({ rowIndex: params.rowIndex, k})}
      />
    </TableCell>
  );
};
